import React, { useState, useContext, useEffect } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import './style/stripe.css'
import {
    Elements,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
    AddressElement,
    useStripe,
    useElements,
} from '@stripe/react-stripe-js'

const CARD_ELEMENT_OPTIONS = {
    style: {
        base: {
            color: '#32325d',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
                color: '#aab7c4',
            },
        },
        invalid: {
            color: '#fa755a',
            iconColor: '#fa755a',
        },
    },
}
const AddCardForm = ({ closePopup }) => {
    const { addNewCard, getStripeCard, responseStatus, clearResponse } =
        useContext(DirectStripeContext)
    const { user, loadUser } = useContext(AuthContext)
    const { setAlert } = useContext(AlertContext)

    const [cardError, setCardError] = useState(null)
    const [addressData, setAddressData] = useState(null)
    const [addressComplete, setAddressComplete] = useState(false)
    const [loader, setLoader] = useState(false)
    const stripe = useStripe()
    const elements = useElements()

    const handleChange = (event) => {
        if (event.error) {
            setCardError(event.error.message)
        } else {
            setCardError(null)
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        if (!stripe || !elements) return

        if (!addressComplete || !addressData) {
            setCardError('Please complete the billing address.')
            return
        }

        setLoader(true)
        setCardError(null)

        const cardNumberElement = elements.getElement(CardNumberElement)
        const { error, token } = await stripe.createToken(cardNumberElement, {
            name: addressData.name || '',
            address_line1: addressData.address?.line1 || '',
            address_line2: addressData.address?.line2 || '',
            address_city: addressData.address?.city || '',
            address_state: addressData.address?.state || '',
            address_zip: addressData.address?.postal_code || '',
            address_country: addressData.address?.country || '',
        })

        if (error) {
            setLoader(false)
            setCardError(error.message)
        } else {
            setCardError(null)
            addNewCard({
                token_id: token.id,
                first_name: addressData.name || '',
                user_id: user?.id,
                site_id: global.storeDetails?.site_id,
            })
        }
    }
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'addNewCard') {
                if (responseStatus.status === 'error') {
                    setLoader(false)
                    setAlert(responseStatus.message, 'error')
                }
                if (responseStatus.status === 'success') {
                    setAlert(responseStatus.message, 'success')
                    if (closePopup) {
                        closePopup()
                    }

                    setLoader(false)
                    clearResponse()
                    getStripeCard({ user_id: user?.id, site_id: global.storeDetails.site_id })
                    if (!user?.card_paymentid) {
                        loadUser()
                    }
                }
            }
        }
    }, [responseStatus])
    return (
        <form className="w-100" onSubmit={handleSubmit}>
            <div className="form-row">
                <div className="col-12 form-group mb-4" style={{ padding: '0px' }}>
                    <label className="lato" htmlFor="card-number-element">
                        Card Number
                    </label>
                    <div
                        className="stripeElementWrapper"
                        style={{
                            padding: '10px',
                            border: '1px solid #ced4da',
                            borderRadius: '4px',
                        }}
                    >
                        <CardNumberElement
                            id="card-number-element"
                            options={CARD_ELEMENT_OPTIONS}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="col-6 form-group mb-4" style={{ paddingLeft: '0px' }}>
                    <label className="lato">Expiry Date</label>
                    <div
                        className="stripeElementWrapper"
                        style={{
                            padding: '10px',
                            border: '1px solid #ced4da',
                            borderRadius: '4px',
                        }}
                    >
                        <CardExpiryElement options={CARD_ELEMENT_OPTIONS} onChange={handleChange} />
                    </div>
                </div>

                <div className="col-6 form-group mb-4" style={{ paddingRight: '0px' }}>
                    <label className="lato">CVC</label>
                    <div
                        className="stripeElementWrapper"
                        style={{
                            padding: '10px',
                            border: '1px solid #ced4da',
                            borderRadius: '4px',
                        }}
                    >
                        <CardCvcElement options={CARD_ELEMENT_OPTIONS} onChange={handleChange} />
                    </div>
                </div>

                <div className="col-12 form-group mb-4" style={{ padding: '0px' }}>
                    <AddressElement
                        options={{
                            mode: 'billing',
                            fields: {
                                phone: 'never',
                            },
                            defaultValues: {
                                address: {
                                    country: global.defaultCountry || 'US',
                                },
                            },
                        }}
                        onChange={(event) => {
                            setAddressData(event.value)
                            setAddressComplete(event.complete)
                        }}
                    />
                </div>

                {cardError && (
                    <div className="col-12 w-100 mb-2" style={{ padding: '0px' }}>
                        <div className="card-errors" role="alert" style={{ color: '#fa755a' }}>
                            {cardError}
                        </div>
                    </div>
                )}
            </div>

            <button type="submit" disabled={loader || !stripe || !elements}>
                {loader ? 'Loading...' : 'Add Card'}
            </button>
        </form>
    )
}

const AddCard = ({ closePopup }) => {
    var stripePromise = loadStripe(global.storeConfigration?.public_key?.value)
    // useEffect(() => {
    //     stripePromise = loadStripe()
    // }, [global.storeConfigration?.public_key?.value])
    return (
        <div className="stripAdCard">
            {global.storeConfigration?.public_key?.value ? (
                <Elements stripe={stripePromise}>
                    <AddCardForm closePopup={closePopup} />
                </Elements>
            ) : null}
        </div>
    )
}
export default AddCard
